import { CatalogItem } from '../CatalogItem';
import { CatalogFilterCondition } from './CatalogFilterCondition';

export function matchCategory(condition: CatalogFilterCondition, item: CatalogItem): boolean {
  if (!condition.category) {
    return true;
  }

  const { kind_id, ui_category, small_genre, is_tool_category } = item;

  switch (condition.category) {
    // かぐ
    case 'furniture': {
      if (
        kind_id !== 'Ftr' &&
        kind_id !== 'DoorDeco' &&
        kind_id !== 'InsectToy' &&
        kind_id !== 'Dishes' &&
        kind_id !== 'Drink' &&
        kind_id !== 'FishToy' &&
        kind_id !== 'FtrWall' &&
        kind_id !== 'Pillar' &&
        kind_id !== 'Counter'
      ) {
        return false;
      }
      if (!condition.subCategory) {
        return true;
      }
      switch (condition.subCategory) {
        case 'housewares': // かぐ
          if (!condition.subSubCategory) {
            return ui_category === 'Floor';
          }
          return ui_category === 'Floor' && matchHousewaresCategory(condition, small_genre);
        case 'miscellaneous': // こもの
          const isMiscellaneousItem =
            ui_category === 'Upper' || ui_category === 'Food' || ui_category === 'Desert';
          if (!condition.subSubCategory) {
            return isMiscellaneousItem;
          }
          return isMiscellaneousItem && matchMiscellaneousCategory(condition, small_genre);
        case 'wall-mounted': // かべかけ
          return ui_category === 'Wall';
        case 'ceilings':
          if (!condition.subSubCategory) {
            return ui_category === 'Ceiling';
          }
          return ui_category === 'Ceiling' && matchCeilingsCategory(condition, small_genre);
        case 'other-furniture':
          return small_genre === 'BuildingMaterial';
        default:
          return false;
      }
    }

    // ファッション
    case 'fashion': {
      if (ui_category !== 'Clothes') {
        return false;
      }
      if (!condition.subCategory) {
        return true;
      }
      switch (condition.subCategory) {
        case 'tops': // トップス
          return kind_id === 'Tops';
        case 'bottoms': // ボトムス
          return kind_id === 'Bottoms';
        case 'dress-up': // ワンピース
          return kind_id === 'OnePiece';
        case 'headwear': // かぶりもの
          return kind_id === 'Cap' || kind_id === 'Helmet';
        case 'accessories': // アクセサリ
          return kind_id === 'Accessory';
        case 'socks': // くつした
          return kind_id === 'Socks';
        case 'shoes': // くつ
          return kind_id === 'Shoes';
        case 'bags': // バッグ
          return kind_id === 'Bag' || kind_id === 'HandBag';
        case 'umbrellas': // かさ
          return kind_id === 'Umbrella';
        case 'other-fashions': // そのほか
          return ![
            'Tops',
            'Bottoms',
            'OnePiece',
            'Cap',
            'Helmet',
            'Accessory',
            'Socks',
            'Shoes',
            'Bag',
            'Umbrella'
          ].includes(kind_id);
        default:
          return false;
      }
    }

    //　かべがみ
    case 'wallpaper':
      if (condition.subCategory) {
        return false;
      }
      if (condition.subSubCategory) {
        return kind_id === 'RoomWall' && matchWallpaperCategory(condition, small_genre);
      } else {
        return kind_id === 'RoomWall';
      }

    //　ゆか
    case 'flooring':
      if (condition.subCategory) {
        return false;
      }
      if (condition.subSubCategory) {
        return kind_id === 'RoomFloor' && matchFlooringCategory(condition, small_genre);
      } else {
        return kind_id === 'RoomFloor';
      }

    // ラグ
    case 'rugs':
      if (condition.subCategory) {
        return false;
      }
      if (condition.subSubCategory) {
        return kind_id === 'Rug' && matchRugsCategory(condition, small_genre);
      } else {
        return kind_id === 'Rug';
      }

    // かせき
    case 'fossils':
      return kind_id === 'Fossil';

    // びじゅつひん
    case 'artwork':
      return (
        kind_id === 'Picture' ||
        kind_id === 'Sculpture' ||
        kind_id === 'PictureFake' ||
        kind_id === 'SculptureFake'
      );

    // けけソング
    case 'kk-songs':
      return kind_id === 'Music';

    // ポスター
    case 'poster':
      return kind_id === 'Poster';

    // どうぐ
    case 'tools':
      return !!is_tool_category;

    case 'haniwa':
      return kind_id === 'Gyroid';

    // さく
    case 'fences':
      return kind_id === 'Fence';

    default:
      return false;
  }
}

function matchHousewaresCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'chairs': // イス
      return small_genre === 'Chair';
    case 'tables': // テーブル
      return small_genre === 'Table';
    case 'beds': // ベッド
      return small_genre === 'Bed';
    case 'closets': // クローゼットなど
      return small_genre === 'Shelf';
    case 'screens': // スクリーンなど
      return small_genre === 'ScreenArch';
    case 'workbenches': // 作業台
      return small_genre === 'WorkBench';
    case 'kitchens': // キッチン
      return small_genre === 'Kitchen';
    case 'stand-light': // 照明
      return small_genre === 'Lamp';
    case 'electrical-appliances-1': // 電化製品など（１）
      return small_genre === 'EntertainmentAppliances';
    case 'musical-instruments': // 楽器
      return small_genre === 'MusicalInstrument';
    case 'electrical-appliances-2': // 電化製品など（２）
      return small_genre === 'AirConditioning';
    case 'baths-and-toilets': // バス・トイレ
      return small_genre === 'Bathroom';
    case 'plant-furniture': // 植物家具
      return small_genre === 'PlantItem';
    case 'indoor-goods': // 屋内系雑貨
      return small_genre === 'FacilityGoods';
    case 'outdoor-goods-1': // 屋外系雑貨（１）
      return small_genre === 'OutdoorGoods';
    case 'outdoor-goods-2': // 屋外系雑貨（２）
      return small_genre === 'HobbyGoods';
    case 'outdoor-goods-3': // 屋外系雑貨（３）
      return small_genre === 'GardeningGoods';
    case 'world-goods': // 世界の雑貨
      return small_genre === 'NationalGoods';
    case 'event-goods': // イベント雑貨
      return small_genre === 'EventGoods';
    default:
      return false;
  }
}

function matchMiscellaneousCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'cushions': // クッション
      return small_genre === 'Chair';
    case 'boxes-and-mirrors': // はこ、かがみ
      return small_genre === 'Table' || small_genre === 'Shelf';
    case 'kitchen-goods': // キッチン
      return small_genre === 'Kitchen';
    case 'foods': // 食べ物
      return small_genre === 'DishFood';
    case 'drinks': // 飲み物
      return small_genre === 'DishDrink';
    case 'lamps': // 照明
      return small_genre === 'Lamp';
    case 'small-electrical-appliances-1': // 電化製品など（１）
      return small_genre === 'EntertainmentAppliances';
    case 'small-musical-instruments': // 楽器
      return small_genre === 'MusicalInstrument';
    case 'bath-and-toilet-goods': // バス・トイレ
      return small_genre === 'Bathroom';
    case 'small-plant-furniture': // 植物家具
      return small_genre === 'PlantItem';
    case 'small-indoor-goods': // 屋内系雑貨
      return small_genre === 'FacilityGoods';
    case 'small-outdoor-goods-1': // 屋外系雑貨（１）
      return small_genre === 'OutdoorGoods';
    case 'small-outdoor-goods-2': // 屋外系雑貨（２）
      return small_genre === 'HobbyGoods';
    case 'small-world-goods': // 世界の雑貨
      return small_genre === 'NationalGoods';
    case 'small-event-goods': // イベント雑貨
      return small_genre === 'EventGoods';
    default:
      return false;
  }
}

function matchCeilingsCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'lighting-fixtures': // 照明
      return small_genre === 'CeilingLamp';
    case 'other-ceiling-furniture': // 天井その他
      return small_genre === 'CeilingEtc';
    default:
      return false;
  }
}

function matchWallpaperCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'normal-wallpaper': // 一般壁
      return small_genre === 'WallNormal';
    case 'special-wallpaper': // 特殊壁
      return small_genre === 'WallSpecial';
    default:
      return false;
  }
}
function matchFlooringCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'normal-flooring': // 一般床
      return small_genre === 'FloorIndoor';
    case 'special-flooring': // 特殊床
      return small_genre === 'FloorOutdoor';
    default:
      return false;
  }
}

function matchRugsCategory(condition: CatalogFilterCondition, small_genre?: string) {
  switch (condition.subSubCategory) {
    case 'square-rugs': // 四角ラグ
      return small_genre === 'RugQuadrilateral';
    case 'round-rugs': // 丸ラグ
      return small_genre === 'RugRound';
    case 'unique-rugs': // ユニークラグ
      return small_genre === 'RugSpecial';
    default:
      return false;
  }
}
